"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JurisdictionRules = void 0;
/**
 * Note that these classes are meant to be singletons instantiated at module load;
 * they are classes because the partial-override ergonomics of TS classes fit the
 * domain we need to model surprisingly well.
 * They should never carry any instance state, only static constants and pure functions.
 *
 * Concerned only with "routine" limits - Subpart L / episodics are handled
 * elsewhere and should be composed together with this by caller
 *
 * Every spec field stays abstract down to the concrete jurisdiction class, so
 * each one authors its own tables rather than inheriting another's.
 */
class JurisdictionRules {
    resolve(ctx) {
        const jurisdictionCtx = this.narrowToJurisdiction(ctx);
        if (jurisdictionCtx.areaType === "CENTRAL") {
            return { areaType: "CENTRAL", clock: this.centralClock(jurisdictionCtx) };
        }
        return {
            areaType: "SATELLITE",
            caps: this.satelliteCaps(jurisdictionCtx),
            clock: this.satelliteClock(jurisdictionCtx),
        };
    }
    /**
     * The facility-wide on-site accumulation thresholds — a fourth slot with a
     * result shape of their own, because a threshold that sums every container at
     * the site is not an area-scoped answer (see ../onSiteCaps.ts).
     */
    resolveAccumulationThresholds(ctx) {
        return this.accumulationThresholds(this.narrowAccumulationThresholdContext(ctx));
    }
}
exports.JurisdictionRules = JurisdictionRules;
//# sourceMappingURL=_base.js.map